import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { CheckCircleIcon, LockIcon } from '@phosphor-icons/react'

import { selectActiveBuilding } from '../../../reducers/buildingSelectorReducer'
import ModalContainer from '../../ModalContainer/ModelContainer'
import Icon from '../../Icons'

import { useAmenityMarketplaceRequestAccess } from './hook'
import { getFeatures, VIDEO_URL } from './utils'

const AmenityMarketplaceModal = ({ isOpen, onClose, selectedBuilding }) => {
  const { t } = useTranslation(['reservations', 'common'])
  const { handleRequestAccess, isLoading, showSuccess, setShowSuccess } =
    useAmenityMarketplaceRequestAccess(selectedBuilding)
  const features = getFeatures(t)

  const handleClose = () => {
    setShowSuccess(false)
    onClose()
  }

  const renderBody = () => {
    if (showSuccess) {
      return (
        <div className="amenity-marketplace-modal__success-content">
          <div className="amenity-marketplace-modal__success-icon">
            <CheckCircleIcon size={64} className="amenity-marketplace-modal__success-icon" />
          </div>
          <h2 className="amenity-marketplace-modal__success-title">
            {t('reservations:amenityMarketplaceModal.successTitle')}
          </h2>
          <p className="amenity-marketplace-modal__success-description">
            {t('reservations:amenityMarketplaceModal.successDescription')}
          </p>
          <button
            className="button amenity-marketplace-modal__close-button-large"
            onClick={handleClose}
          >
            {t('common:actions.close')}
          </button>
        </div>
      )
    }

    return (
      <>
        <div className="amenity-marketplace-modal__lock-notice">
          <LockIcon size={24} weight="fill" className="amenity-marketplace-modal__lock-icon" />
          <span className="amenity-marketplace-modal__lock-text">
            {t('reservations:amenityMarketplaceModal.featureLocked')}
          </span>
        </div>
        <h3 className="amenity-marketplace-modal__subtitle">
          {t('reservations:amenityMarketplaceModal.subtitle')}
        </h3>
        <p className="amenity-marketplace-modal__feature">
          {t('reservations:amenityMarketplaceModal.description')}
        </p>
        <h4 className="amenity-marketplace-modal__subtitle">
          {t('reservations:amenityMarketplaceModal.whyYoullLoveIt')}
        </h4>
        <ul className="amenity-marketplace-modal__features">
          {features.map((feature) => (
            <li key={feature.title} className="amenity-marketplace-modal__feature">
              <CheckCircleIcon size={20} />
              <div>
                <strong>{feature.title}:</strong> {feature.description}
              </div>
            </li>
          ))}
        </ul>

        <div className="amenity-marketplace-modal__video-container">
          <video
            className="amenity-marketplace-modal__video"
            controls
            preload="auto"
            poster={VIDEO_URL}
          >
            <source src={VIDEO_URL} type="video/mp4" />
            {t('reservations:amenityMarketplaceModal.videoNotSupported')}
          </video>
        </div>

        <div className="amenity-marketplace-modal__actions">
          <button
            className={`button button-primary amenity-marketplace-modal__cta-button ${
              isLoading ? 'is-loading' : ''
            }`}
            onClick={handleRequestAccess}
            disabled={isLoading}
          >
            {t('reservations:amenityMarketplaceModal.requestAccess')}
          </button>
        </div>
      </>
    )
  }

  return (
    <ModalContainer
      isVisible={isOpen}
      onClose={onClose}
      headerTitle={t('reservations:amenityMarketplaceModal.headerTitle')}
      headerIcon={<Icon icon="reservation" viewBox="0 0 24 24" />}
      additionalClass="amenity-marketplace-modal-container"
    >
      <div className="amenity-marketplace-modal">{renderBody()}</div>
    </ModalContainer>
  )
}

AmenityMarketplaceModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  selectedBuilding: PropTypes.object,
}

export default connect((state) => ({
  selectedBuilding: selectActiveBuilding(state),
}))(AmenityMarketplaceModal)
